Vue.component("app-layout", require("../layouts/App.vue").default);
Vue.component("app-bar", require("./AppBar/AppBar.vue").default);
Vue.component("app-footer", require("./Footer/Footer.vue").default);
Vue.component("page-home-when", require("../pages/PageHomeWhen.vue").default);
Vue.component("app-banner", require("./Banner/Banner.vue").default);
Vue.component(
  "app-banner-gift",
  require("./BannerGift/BannerGift.vue").default
);
Vue.component(
  "app-banner-search",
  require("../layouts/BannerSearch/BannerSearch.vue").default
);
Vue.component(
  "app-banner-destination",
  require("../layouts/BannerDestination/BannerDestination.vue").default
);
Vue.component(
  "app-banner-giftdestination",
  require("../layouts/BannerGiftDestination/BannerGiftDestination.vue").default
);
Vue.component(
  "app-search-box",
  require("../modules/searcher/components/SearchBox/SearchBox.vue").default
);
Vue.component(
  "app-compact-search",
  require("../modules/searcher/CompactSearcher.vue").default
);
Vue.component(
  "app-banner-blog",
  require("./BannerBlog/BannerBlog.vue").default
);
Vue.component(
  "app-banner-newsletter",
  require("./BannerNewsletter/BannerNewsletter.vue").default
);
Vue.component("app-card-blog", require("./CardBlog/CardBlog.vue").default);
Vue.component(
  "app-destinies-carousel",
  require("./DestiniesCarousel/DestiniesCarousel.vue").default
);
Vue.component(
  "app-blog-carousel",
  require("./BlogCarousel/BlogCarousel.vue").default
);
Vue.component("app-card-icon", require("./CardIcon/CardIcon.vue").default);
Vue.component(
  "app-card-travel-icon",
  require("./CardTravelIcon/CardTravelIcon.vue").default
);
Vue.component(
  "app-card-optional-icon",
  require("./CardOptionalIcon/CardOptionalIcon.vue").default
);
Vue.component(
  "app-card-destiny",
  require("./CardDestiny/CardDestiny.vue").default
);
Vue.component(
  "app-card-destiny-bg",
  require("./CardDestinyBg/CardDestinyBg.vue").default
);
Vue.component(
  "app-card-confirmation",
  require("../modules/booking/components/Stepper/CardConfirmation/CardConfirmation.vue")
    .default
);
Vue.component(
  "app-section-brands",
  require("../layouts/SectionBrands/SectionBrands.vue").default
);
Vue.component(
  "app-section-info-icons",
  require("../layouts/SectionInfoIcons/SectionInfoIcons.vue").default
);
Vue.component(
  "app-section-travel-icons",
  require("../layouts/SectionTravelIcons/SectionTravelIcons.vue").default
);
Vue.component(
  "app-section-optionals-icons",
  require("../layouts/SectionOptionalsIcons/SectionOptionalsIcons.vue").default
);
Vue.component(
  "app-stepper",
  require("../modules/booking/components/Stepper/Stepper.vue").default
);
Vue.component(
  "app-step",
  require("../modules/booking/components/Stepper/Step/Step.vue").default
);
Vue.component(
  "app-step-details",
  require("../modules/booking/components/Stepper/Step/StepDetails/StepDetails.vue")
    .default
);
Vue.component(
  "app-step-extras",
  require("../modules/booking/components/Stepper/Step/StepExtras/StepExtras.vue")
    .default
);
Vue.component(
  "app-step-data",
  require("../modules/booking/components/Stepper/Step/StepData/StepData.vue")
    .default
);
Vue.component("app-box-booking", require("./BoxBooking.vue").default);
Vue.component(
  "app-box-booking-summary",
  require("../modules/booking/components/Stepper/BoxBookingSummary/BoxBookingSummary.vue")
    .default
);
Vue.component(
  "app-box-timer",
  require("../modules/booking/components/Stepper/BoxTimer/BoxTimer.vue").default
);
Vue.component("app-box-icon", require("./BoxIcon/BoxIcon.vue").default);
Vue.component(
  "app-box-checkbox",
  require("./BoxCheckbox/BoxCheckbox.vue").default
);

Vue.component("app-counter", require("./Counter/Counter.vue").default);
Vue.component("app-box-header", require("./BoxHeader.vue").default);
Vue.component("app-box-extras", require("./BoxExtras.vue").default);
Vue.component(
  "app-destinies-container",
  require("./DestiniesContainer/DestiniesContainer.vue").default
);
Vue.component(
  "app-form-adult",
  require("../modules/booking/components/Stepper/Step/StepData/Forms/FormAdult/FormAdult.vue")
    .default
);
Vue.component(
  "funnel-contact-form",
  require("../modules/booking/components/Stepper/Step/StepData/Forms/FunnelContactForm/FunnelContactForm.vue").default
);
Vue.component( "app-packavm-form",
  require("../modules/booking/components/Stepper/Step/StepData/Forms/PackAvm/PackAvm.vue").default
);
Vue.component(
  "app-fixed-booking-summary",
  require("../modules/booking/components/Stepper/FixedBookingSummary/FixedBookingSummary.vue")
    .default
);
Vue.component(
  "icon-one-day",
  require("./Icons/IconOneDay/IconOneDay.vue").default
);
Vue.component(
  "icon-multiple-days",
  require("./Icons/IconMultipleDays/IconMultipleDays.vue").default
);
Vue.component(
  "calendar-component",
  require("../modules/calendar/Calendar.vue").default
);
Vue.component(
  "calendar-controller",
  require("../modules/calendar/CalendarController.vue").default
);
Vue.component(
  "app-categories-scrollable",
  require("./Scrollable/CategoriesScrollable.vue").default
);
Vue.component("app-blog", require("./Blog/Blog.vue").default);
Vue.component(
  "app-horizontal-carousel",
  require("./HorizontalCarousel/HorizontalCarousel.vue").default
);
Vue.component(
  "redsys-component",
  require("./Payment/RedsysComponent.vue").default
);
Vue.component(
  "paypal-component",
  require("./Payment/PaypalComponent.vue").default
);
Vue.component(
  "wrapper-booking",
  require("../modules/booking/BookingController.vue").default
);
Vue.component(
  "app-gift-card-destination",
  require("./GiftCardDestination/GiftCardDestination.vue").default
);
Vue.component("snackbar-component", require("./Snackbar/Snackbar.vue").default);
Vue.component(
  "last-posts-component",
  require("./LastPostsComponent/LastPostsComponent.vue").default
);
Vue.component(
  "app-search-box-navbar",
  require("../modules/searcher/components/SearchBoxNavbar/SearchBoxNavbar.vue")
    .default
);
Vue.component(
  "app-search-form",
  require("../modules/searcher/components/SearchForm/SearchForm.vue").default
);
Vue.component(
  "app-search-form-more-days",
  require("../modules/searcher/components/SearchFormMoreDays/SearchFormMoreDays.vue")
    .default
);
Vue.component(
  "app-search-box-navbar-more-days",
  require("../modules/searcher/components/SearchBoxNavbarMoreDays/SearchBoxNavbarMoreDays.vue")
    .default
);
Vue.component(
  "redsys-data-component",
  require("./RedsysData/RedsysData.vue").default
);
Vue.component(
  "payment-methods-component",
  require("../modules/booking/components/Stepper/Step/StepData/PaymentMethod/PaymentMethod.vue")
    .default
);
Vue.component(
  "terms-component",
  require("../modules/booking/components/Stepper/Step/StepData/Terms/Terms.vue")
    .default
);
Vue.component(
  "comfirmation-component",
  require("../modules/booking/components/Stepper/Step/StepData/ComfirmComponent/Comfirm.vue")
    .default
);
Vue.component(
  "admin-calendar-component",
  require("./AdminCalendar/AdminCalendar.vue").default
);
Vue.component(
  "app-flight-info",
  require("./FlightInfo/FlightInfo.vue").default
);
Vue.component(
  "app-home-verticals",
  require("./HomeVerticals/HomeVerticals.vue").default
);
Vue.component(
  "app-moredays-searcher",
  require("../modules/searcher/MoreDaysSearcher.vue").default
);
Vue.component(
  "app-revolution-travels",
  require("./RevolutionTravels/RevolutionTravels.vue").default
);
Vue.component(
  "app-flex-avm-module",
  require("./FlexAvmModule/FlexAvmModule.vue").default
);
Vue.component(
  "app-results-controller",
  require("../modules/results/ResultsController.vue").default
);
Vue.component("app-top-destinations",
  require("../modules/topDestinations/TopDestinations.vue").default
);
Vue.component("app-one-day-travels-container",
  require("./OneDayTravelsContainer/OneDayTravelsContainer.vue").default
);
Vue.component("app-oneday-searcher",
  require("../modules/searcher/OneDaySeacher.vue").default
);
Vue.component("app-home-cover",
  require("./HomeCover/HomeCover.vue").default
);
Vue.component("app-box-booking-info",
  require("../modules/booking/components/Stepper/BoxBookingInfo/BoxBookingInfo.vue").default
);
Vue.component("app-pack-avm",
  require("./PackAvm.vue").default
);
